export default __webpack_public_path__ + "static/media/fondo.d826b8fb.jpg";